import axios from 'axios';

const personPipedrive = async (personEmail = '', articleTitle = '') => {
  let personId = null;

  const GUIDE_KEY = 'c1b025387123ca6020e3ff7951b0f639133a2b8c';
  const SOURCE_KEY = '5edd6aac97fc0a862d765cf59a172797d982be7e';

  const apiToken = process.env.PIPEDRIVE_API_KEY;

  try {
    const personByEmail = await axios(
      `https://api.pipedrive.com/v1/persons/search?term=${personEmail}&fields=email&start=0&api_token=${apiToken}`
    );

    // if pesron exist
    if (personByEmail.data.data.items.length > 0) {
      let isNewGuide;

      personId = personByEmail.data.data.items[0].item.id;

      const personById = await axios(
        `https://c22.pipedrive.com/api/v1/persons/${personId}?api_token=${apiToken}`
      );

      // console.log(personById, 'personById');

      const personDownloadGuide = personById.data.data[GUIDE_KEY] || '';

      if (!personDownloadGuide.includes(articleTitle)) {
        isNewGuide =
          personDownloadGuide === ''
            ? articleTitle
            : personDownloadGuide + ', ' + articleTitle;

        const dataToUpdate = {
          [GUIDE_KEY]: isNewGuide,
        };

        return await axios({
          method: 'put',
          url: `https://c22.pipedrive.com/api/v1/persons/${personId}?api_token=${apiToken}`,
          data: dataToUpdate,
        });
      }

      // const personDetails = await axios(
      //   `https://c22.pipedrive.com/api/v1/personFields:(key,name,options)?start=0&api_token=${apiToken}`
      // );

      // console.log(personDetails, 'personDetails');
    } else {
      let newPersonData = {
        name: 'Guide User',
        email: [{ value: personEmail, primary: 'true', label: 'main' }],
        [SOURCE_KEY]: '139',
        [GUIDE_KEY]: articleTitle,
      };

      return await axios({
        method: 'post',
        url: `https://c22.pipedrive.com/api/v1/persons?api_token=${apiToken}`,
        data: newPersonData,
      });
    }

    // console.log(personByEmail.data);
  } catch (error) {
    console.info(error, 'error');

    new Error(error);
  }
};

export default personPipedrive;
